import { api } from "@/lib/api/api";
import { CliError } from "@/lib/cli/cli-error";
import { path } from "@/lib/path/path";
import { out } from "@/lib/output/out";
import { printSession } from "@/lib/session/print-session";
import { detail } from "@/commands/detail/detail";
import { CONTROL_PATHS } from "@/commands/sessions/sessions-constants";
import type { ParsedArgs } from "@/lib/parsed/parsed-args";

export async function runSessionControlAction(
  parsed: ParsedArgs,
  action: string,
  sessionId: string,
  asJson: boolean,
): Promise<void> {
  const controlPath = CONTROL_PATHS[action];
  if (controlPath === undefined) {
    throw new CliError(`Unknown session action: ${action}`, 2);
  }
  const session = detail(
    await api(path`/sessions/${sessionId}/${controlPath}`, {
      method: "POST",
      body:
        action === "kill" && parsed.flags.reason
          ? { reason: parsed.flags.reason }
          : {},
    }),
    `POST /sessions/{id}/${controlPath}`,
  );
  if (asJson) {
    out.json(session);
    return;
  }
  printSession(session);
}
